import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api') + '/partner';

export const getPartnerScreens = createAsyncThunk('screen/getAll', async ({ userId, theaterId }) => {
  const r = await axios.get(`${API}/screens/${userId}`, { params: { theaterId } }); return r.data;
});
export const addPartnerScreen = createAsyncThunk('screen/add', async ({ userId, screenData }) => {
  const r = await axios.post(`${API}/screens/${userId}`, screenData); return r.data;
});
export const updatePartnerScreen = createAsyncThunk('screen/update', async ({ userId, screenId, data }) => {
  const r = await axios.patch(`${API}/screens/${userId}/${screenId}`, data); return r.data;
});
export const deletePartnerScreen = createAsyncThunk('screen/delete', async ({ userId, screenId }) => {
  const r = await axios.delete(`${API}/screens/${userId}/${screenId}`); return r.data;
});
export const updateScreenLayout = createAsyncThunk('screen/updateLayout', async ({ userId, screenId, seatLayout }) => {
  const r = await axios.patch(`${API}/screens/${userId}/${screenId}/layout`, { seatLayout }); return r.data;
});

const screenSlice = createSlice({
  name: 'screen',
  initialState: { screens: [], theaterId: null, loading: false, error: null },
  reducers: {
    clearScreenState: (state) => { state.screens = []; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerScreens.pending, (state) => { state.loading = true; })
      .addCase(getPartnerScreens.fulfilled, (state, action) => {
        state.loading = false; state.screens = action.payload.screens; state.theaterId = action.payload.theaterId;
      })
      .addCase(getPartnerScreens.rejected, (state) => { state.loading = false; })
      .addCase(addPartnerScreen.fulfilled, (state, action) => { state.screens = action.payload.screens; })
      .addCase(updatePartnerScreen.fulfilled, (state, action) => { state.screens = action.payload.screens; })
      .addCase(deletePartnerScreen.fulfilled, (state, action) => { state.screens = action.payload.screens; })
      .addCase(updateScreenLayout.fulfilled, (state, action) => { state.screens = action.payload.screens; });
  }
});

export const { clearScreenState } = screenSlice.actions;
export default screenSlice.reducer;
